export default "__VITE_ASSET__4afb1ef0__"